import React, { Component } from 'react'
import { FilledStarIcon, LastTripIcon, StarIcon } from '../icons/Icons';

export default class LastTrip extends Component {
    constructor(props) {
        super(props);

        this.state = {isActive: this.props.fav}
        this.toggleActive = this.toggleActive.bind(this);
    }

    toggleActive() {
        let newState = !this.state.isActive;
        this.setState({isActive: newState});

        let lastTrips = JSON.parse(localStorage.getItem("lastTrips"));
        let favoritesTrips = JSON.parse(localStorage.getItem("favoritesTrips"));
        if (!lastTrips) lastTrips = [];
        if (!favoritesTrips) favoritesTrips = [];

        if(newState){
            lastTrips.forEach((trip,id) => {
                if (trip.origin.id == this.props.trip.origin.id &&
                    trip.destination.id == this.props.trip.destination.id) {
                    lastTrips.splice(id,1);
                    return;
                }
            });
            favoritesTrips.unshift(this.props.trip);
        }else{
            favoritesTrips.forEach((trip,id) => {
                if (trip.origin.id == this.props.trip.origin.id &&
                    trip.destination.id == this.props.trip.destination.id) {
                        favoritesTrips.splice(id,1);
                    return;
                }
            });
            lastTrips.unshift(this.props.trip);
        }
        localStorage.setItem("lastTrips", JSON.stringify(lastTrips));
        localStorage.setItem("favoritesTrips", JSON.stringify(favoritesTrips));
    }

    render() {
        return (
            <div style={{ background: this.props.index % 2 === 0 ? "#fff" : "#eee", padding: '8px 20px', color: '#003366', display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '20px' }}>
                <div style={{ display: 'flex', alignItems: "center" }}>
                    <LastTripIcon style={{ height: '60px', flexShrink: "0" }} />
                    <div style={{ cursor: 'pointer' }} onClick={() => {
                        this.props.setOrigin(this.props.trip.origin);
                        this.props.setDestination(this.props.trip.destination);
                    }}>
                        {this.props.trip.origin.name}, {this.props.trip.origin.city} <br /> {this.props.trip.destination.name}, {this.props.trip.destination.city}
                    </div>
                </div>

                <div style={{ marginLeft: '50px', cursor: 'pointer' }} onClick={() => {
                    this.toggleActive();
                }}>
                {this.state.isActive ? (
                    <FilledStarIcon style={{height: '30px'}}/>
                ) : (
                    <StarIcon style={{ height: '30px' }} />
                )}
                </div>
            </div>
        )
    }
}
